import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { saveToken } from "../../token/token";

function OAuth2RedirectHandler() {
  const [searchParams, setSearchParams] = useSearchParams();

  // useEffect(() => {
  //     console.log(searchParams.get("token"));
  //     sessionStorage.setItem("token", searchParams.get("accesstoken"));

  //     dispatch(getQuiz());
  //   }, [searchParams]);

  const token = searchParams.get("token");
  const error = searchParams.get("error");

  if (token) {
    saveToken(token);
    window.location = "/dashboard";
  } else {
    return (
      <Navigate
        to={{
          pathname: "/",
        }}
      />
    );
  }
}

export default OAuth2RedirectHandler;
